import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import MdArrowDropUp from 'react-icons/lib/md/arrow-drop-up'
import MdArrowDropDown from 'react-icons/lib/md/arrow-drop-down'
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from './Button';
import TabHeader from './TabHeader';

const propTypes = {
  children: PropTypes.node.isRequired,
  direction: PropTypes.string,
  headerLabel: PropTypes.node.isRequired,
  hideContentToggle: PropTypes.bool,
  onStateChange: PropTypes.func,
};

const defaultProps = {
  direction: 'column',
  hideContentToggle: false,
  onStateChange: () => {},
};

/*
 * Exportable container to create content for show more / show less
 * toggle.
 */
const Minifiable = styled.div``;

const ContentToggler = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  top: -18px;
  width: 100%;
`;

const TogglerIcon = styled.i`
  height: 100%;
  width: auto;
  margin-left: -9px;
`;

const Content = styled.div`
  box-shadow: 0 1px 25px 3px ${props => props.theme['grey-normal']};
  display: flex;
  flex-direction: ${
    props => props.direction === 'column'
      ? 'column'
      : 'row'
    };
  flex-wrap: wrap;

  & > div {
    background-color: #ffffff;
    box-sizing: border-box;
    padding: 20px;
    position: relative;
    width: 100%;
    z-index: 2;

    @media (min-width: 480px) {
      padding: 40px;
    }
  }

  ${Minifiable} {
    ${props => props.minified
      ? 'display: none'
      : ''
    };
  }
`;

const Component = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${ContentToggler} {
    z-index: 3;
  }
`;

class Box extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      minified: true,
    };
  }

  onStateChange = evnt => {
    evnt.preventDefault();
    this.switchState();
  }

  switchState = () => {
    const { onStateChange } = this.props;
    this.setState({ minified: !this.state.minified }, () => onStateChange())
  }

  render() {
    const { children, direction, headerLabel, hideContentToggle } = this.props;
    const { minified } = this.state;
    return (
      <Component {...this.props}>
        <TabHeader>
          {headerLabel}
        </TabHeader>

        <Content direction={direction} minified={minified}>
          <div>
            {children}
          </div>
        </Content>

        {!hideContentToggle && (
          <ContentToggler>
            <Button
              onClick={this.onStateChange}
              size='medium'
              color='grey'
            >
              {minified && (
                <React.Fragment>
                  <TogglerIcon as={MdArrowDropDown} />
                  <FormattedMessage id='contentToggler.showMore' />
                </React.Fragment>
              )}
              {!minified && (
                <React.Fragment>
                  <TogglerIcon as={MdArrowDropUp} />
                  <FormattedMessage id='contentToggler.showLess' />
                </React.Fragment>
              )}
            </Button>
          </ContentToggler>
        )}
      </Component>
    );
  }
}

Box.propTypes = propTypes;
Box.defaultProps = defaultProps;

export default Box;
export { Minifiable };
